import { Box, Grid2, Step, StepLabel, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SnackBar from "../../../component/SnackBar";
import { QUICKMATCH } from "../../../redux/Action";
import { JobJobDelete } from "../../../redux/action/Job";
import {
  ReviewMatchInformation,
  UploadJob,
} from "../../../redux/action/QuickMatch";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import ErrorDialog from "./components/ErrorDialog";
import ReviewMatch from "./components/ReviewMatch";
import UploadCandidate from "./components/UploadCandidate";
import UploadJobInformation from "./components/UploadJobInformation";
import {
  trackFeatureUsage,
  trackFeatureFailure,
} from "../../mixpanel/mixpanel";
// import { StepperStyle, StepperTabList } from "../../onboarding/style";
import PageStepperDefaultIco from "../../../assets/icons/PageStepperDefaultIco";
import StepperActiveIco from "../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../assets/icons/StepperInprogressIco";
import { StepperStyle } from "./style";
import { CustomDiv } from "../../chat-bot/style";
import { TeamGetCall } from "../../../redux/action/UserManagement";
import { handleDataTime } from "../../common-components/JobFunction";

function QuickMatch() {
  const [value, setValue] = useState(0);
  const [files, setFiles] = useState([]);
  const [candidateFiles, setCandidateFiles] = useState([]);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isCandidateDragging, setIsCandidateDragging] = useState(false);
  const [isAddMoreCandidateDragging, setIsAddMoreCandidateDragging] =
    useState(false);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [jobTitle, setJobTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [uploadJobData, setUploadJobData] = useState({});
  const [uploadJobDataList, setUploadJobDataList] = useState([]);
  const dispatch = useDispatch();
  const reviewMatchData = useSelector(
    (state) => state.quickMatchState.reviewMatch
  );
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [wrongClose, setWrongClose] = useState(false);
  const navigate = useNavigate();
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [deleteResume, setDeleteResume] = useState(false);
  const [resumeRow, setResumeRow] = useState({});
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [userData, setUserData] = useState({
    account_executive: { username: "", id: "" },
    job_owner: { username: "", id: "" },
    user_list: [],
    date_time: null,
    loading: false,
  });

  const uploadFile = async (getName, setCandidateFiles, getAddMore) => {
    setIsLoading(true);
    setButtonDisabled(true);
    if (getName === "NextUpload") {
      setFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          delete: false,
        }))
      );
    } else {
      setCandidateFiles((prevFiles) =>
        prevFiles.map((f) => ({
          ...f,
          delete: false,
        }))
      );
    }
    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    ) {
      const interval = setInterval(() => {
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) => {
            const updatedProgress = f.progress + 10;
            const isComplete = updatedProgress >= 100;

            if (isComplete) {
              clearInterval(interval);

              setTimeout(() => {
                setTabData((prev) =>
                  prev.map((tab, index) =>
                    index < 1 ? { ...tab, disabled: true } : tab
                  )
                );
                dispatch({
                  type: QUICKMATCH.reviewMatch,
                  data: [],
                });
                if (getName === "NextUpload") {
                  setValue(1);
                  setTabData((prev) =>
                    prev.map((tab, index) =>
                      index === 0
                        ? { ...tab, status: "Completed" }
                        : index === 1
                        ? { ...tab, status: "In Progress" }
                        : tab
                    )
                  );
                } else if (getAddMore === "Add-more-Candidate") {
                  setAddMoreCandidateDialogOpen(false);
                  dispatch({
                    type: QUICKMATCH.reviewMatch,
                    data: [...reviewMatchData, ...prevFiles].map(
                      (item, index) => ({
                        candidate_name: item?.name || item?.candidate_name,
                        score: "80",
                        id: index,
                      })
                    ),
                  });
                } else if (getName === "Upload-Candidate") {
                  dispatch({
                    type: QUICKMATCH.reviewMatch,
                    data: candidateFiles.map((item, index) => ({
                      candidate_name: item?.name,
                      score: "80",
                      id: index,
                    })),
                  });
                  setTabData((prev) =>
                    prev.map((tab, index) =>
                      index <= 2 ? { ...tab, status: "Completed" } : tab
                    )
                  );
                  setValue(2);
                }
                setIsLoading(false);
                setButtonDisabled(false);
                setSnackbarState({
                  open: true,
                  message: "Update Successfully",
                  severity: "success",
                });
              }, 500);

              return { ...f, progress: 100, buffer: 100 };
            }

            return {
              ...f,
              progress: updatedProgress,
              buffer: updatedProgress,
              visible: false,
              delete: false,
            };
          })
        );
      }, 300);

      setTimeout(() => clearInterval(interval), 4000);
    } else {
      const formData = new FormData();
      if (getName === "NextUpload") {
        files.forEach((fileObj, index) => {
          formData.append("files", fileObj.file);
        });
        formData.append("account_executive", userData?.account_executive?.id);
        formData.append("job_owner", userData?.job_owner?.id);
        formData.append(
          "submission_deadline",
          userData?.date_time
            ? new Date(
                userData.date_time.format("YYYY-MM-DDTHH:mm:ss")
              ).toISOString()
            : ""
        );
      } else if (getAddMore === "Add-more-Candidate") {
        addMoreCandidateFiles.forEach((fileObj, index) => {
          formData.append("resume_file", fileObj.file);
        });
        formData.append("id", uploadJobData?.data?.id);
      } else {
        candidateFiles.forEach((fileObj, index) => {
          formData.append("resume_file", fileObj.file);
        });
        formData.append("id", uploadJobData?.data?.id);
      }
      try {
        const response = await UploadJob(formData, getName, "Active");
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(
                jsonResponse,
                getName,
                setCandidateFiles,
                getAddMore
              );
            } catch (e) {
              if (getName === "NextUpload") {
                setFiles((prevFiles) =>
                  prevFiles.map((f) => ({
                    ...f,
                    visible: true,
                    delete: true,
                    message: jsonResponse.message,
                  }))
                );
                setWrongClose(true);
              } else {
                setSnackbarState({
                  open: true,
                  message: "Error parsing JSON",
                  severity: "error",
                });
                setCandidateFiles((prevFiles) =>
                  prevFiles.map((f) =>
                    f.name === jsonResponse.data.current_resume
                      ? {
                          ...f,
                          visible: true,
                          delete: true,
                        }
                      : { ...f, delete: true }
                  )
                );
              }
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(
              jsonResponse,
              getName,
              setCandidateFiles,
              getAddMore
            );
          } catch (e) {
            if (getName === "NextUpload") {
              setFiles((prevFiles) =>
                prevFiles.map((f) => ({
                  ...f,
                  visible: true,
                  delete: true,
                  message: jsonResponse.message,
                }))
              );
              setWrongClose(true);
            } else {
              setSnackbarState({
                open: true,
                message: "Error parsing final JSON chunk",
                severity: "error",
              });
              setCandidateFiles((prevFiles) =>
                prevFiles.map((f) =>
                  f.name === jsonResponse.data.current_resume
                    ? {
                        ...f,
                        visible: true,
                        delete: true,
                      }
                    : { ...f, delete: true }
                )
              );
            }
          }
        }
        setIsLoading(false);
        setButtonDisabled(false);
      } catch (error) {
        if (getName === "NextUpload") {
          setFiles((prevFiles) =>
            prevFiles.map((f) => ({
              ...f,
              visible: true,
              delete: true,
              message: "Error during the request",
            }))
          );

          setWrongClose(true);

          // Track upload failure
          trackFeatureFailure("Quick Match JD Upload failed", error, {
            file_count: files.length,
            file_types: files.map((f) => f.type),
            timestamp: new Date().toISOString(),
          });
        } else {
          setSnackbarState({
            open: true,
            message: "Error during the request",
            severity: "error",
          });
          setCandidateFiles((prevFiles) =>
            prevFiles.map((f) => ({
              ...f,
              visible: true,
              delete: true,
              message: "Error during the request",
            }))
          );

          // Track candidate upload/report generation failure
          trackFeatureFailure("Quick Match: Report gen failed", error, {
            candidate_count: candidateFiles.length,
            file_types: candidateFiles.map((f) => f.type),
            timestamp: new Date().toISOString(),
          });
        }
        setIsLoading(false);
        setButtonDisabled(false);
      }
    }
  };

  const processJsonResponse = (
    jsonResponse,
    getName,
    setCandidateFiles,
    getAddMore
  ) => {
    const { success, data, message } = jsonResponse;
    setUploadJobDataList(data);
    if (success && data?.percent !== undefined) {
      if (getName === "NextUpload") {
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            progress: data.percent,
            buffer: data.buffer || data.percent,
            progress_message: data.progress_message,
            visible: false,
            delete: false,
          }))
        );
      } else {
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) =>
            f.name === data.current_resume
              ? {
                  ...f,
                  progress: data.percent,
                  progress_message: data.progress_message,
                  buffer: data.buffer || data.percent,
                  visible: false,
                  delete: false,
                }
              : f
          )
        );
      }
    } else if (data?.id && getName === "NextUpload") {
      setUploadJobData(jsonResponse);
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });

      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Completed" }
            : index === 1
            ? { ...tab, status: "In Progress" }
            : tab
        )
      );
      setValue(1);
      // Track successful upload
      trackFeatureUsage("Quick Match JD Uploaded", {
        job_id: data.id,
        file_count: files.length,
        file_types: files.map((f) => f.type),
        timestamp: new Date().toISOString(),
      });
    } else if (
      getAddMore === "Add-more-Candidate" &&
      Array.isArray(data) &&
      data?.length !== 0
    ) {
      setAddMoreCandidateDialogOpen(false);
      setAddMoreCandidateFiles([]);
      handleReviewMatchInformation();
    } else if (
      Array.isArray(data) &&
      data?.length !== 0 &&
      getName === "Upload-Candidate"
    ) {
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 2 ? { ...tab, status: "Completed" } : tab
        )
      );
      setValue(2);

      // Track successful candidate upload/report generation
      trackFeatureUsage("Quick Match Candidate Report Generated", {
        candidate_count: candidateFiles.length,
        file_types: candidateFiles.map((f) => f.type),
        timestamp: new Date().toISOString(),
      });
    } else if (!success) {
      if (getName === "NextUpload") {
        setFiles((prevFiles) =>
          prevFiles.map((f) => ({
            ...f,
            visible: true,
            delete: true,
            message: message,
          }))
        );
        setWrongClose(true);
      } else {
        setWrongClose(true);
        setCandidateFiles((prevFiles) =>
          prevFiles.map((f) =>
            f.name === data.current_resume || data.length === 0
              ? {
                  ...f,
                  visible: true,
                  delete: true,
                  message: message,
                }
              : { ...f, delete: true }
          )
        );
      }
    }
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };
  // Handle file upload through input
  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(selectedFiles, allowedTypes, setFiles, files);
  };

  // Handle file deletion
  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  // Drag-and-drop functionality
  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(droppedFiles, allowedTypes, setFiles, files);
  };

  const handleCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setCandidateFiles,
      candidateFiles
    );
  };

  const handleCandidateDeleteFile = (index) => {
    setCandidateFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (files.length === 0 && value === 0) {
      setTabData((prev) =>
        prev.map((tab, index) => ({ ...tab, disabled: true }))
      );
      setIsLoading(false);
      setButtonDisabled(false);
    }
    if (candidateFiles.length === 0 && value === 1) {
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 2 ? { ...tab, disabled: true } : tab
        )
      );
      setIsLoading(false);
      setButtonDisabled(false);
    }
    if (addMoreCandidateFiles.length === 0 && value === 2) {
      setIsLoading(false);
      setButtonDisabled(false);
    }
    if (files.length !== 0 && value === 0) {
      const getData = files.some((item) => item.visible);
      if (getData) {
        setIsLoading(false);
        setButtonDisabled(true);
      }
    } else if (
      (candidateFiles.length !== 0 && value === 1) ||
      (addMoreCandidateFiles.length !== 0 && value === 2)
    ) {
      const getData = (
        value === 1 ? candidateFiles : addMoreCandidateFiles
      ).every((item) => item.visible);

      if (getData) {
        setIsLoading(false);
        setButtonDisabled(true);
      }
    }
  }, [files, candidateFiles, addMoreCandidateFiles]);

  const handleReviewMatchInformation = async () => {
    try {
      setTableLoader(true);
      await dispatch(ReviewMatchInformation(uploadJobData.data.id));

      setTableLoader(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setTableLoader(false);
    }
  };
  useEffect(() => {
    if (
      localStorageData?.organization === "Demo" &&
      localStorageData?.role === "Demo"
    )
      return;
    if (value === 2) {
      handleReviewMatchInformation();
    }
  }, [value]);
  useEffect(() => {
    fetchUsersList();
  }, []);

  const fetchUsersList = async () => {
    try {
      setUserData((prev) => ({
        ...prev,
        loading: true,
      }));
      const usersList = await TeamGetCall();
      setUserData((prev) => ({
        ...prev,
        user_list: usersList?.data || [],
        loading: false,
      }));
    } catch (error) {
      setUserData((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleCandidateDragOver = (event) => {
    event.preventDefault();
    setIsCandidateDragging(true);
  };

  const handleCandidateDragLeave = () => {
    setIsCandidateDragging(false);
  };

  const handleCandidateDrop = (event) => {
    event.preventDefault();
    setIsCandidateDragging(false);
    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setCandidateFiles,
      candidateFiles
    );
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleAddMoreCandidateDeleteFile = (index) => {
    setAddMoreCandidateFiles((prevFiles) =>
      prevFiles.filter((_, i) => i !== index)
    );
  };

  const handleAddMoreCandidateDragOver = (event) => {
    event.preventDefault();
    setIsAddMoreCandidateDragging(true);
  };

  const handleAddMoreCandidateDragLeave = () => {
    setIsAddMoreCandidateDragging(false);
  };

  const handleAddMoreCandidateDrop = (event) => {
    event.preventDefault();
    setIsLoading(false);
    setIsAddMoreCandidateDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleQmShare = () => {
    setShareDialogOpen(true);
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
  };

  const [tabData, setTabData] = useState([
    {
      label: "Upload Job Information",
      status: "In Progress",
    },
    {
      label: "Upload Candidates",
      status: "Pending",
    },
    {
      label: "Review Match Information",
      status: "Pending",
    },
  ]);

  const handleNextUploadClick = async () => {
    if (files.length == 0) {
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Upload the Files",
        severity: "error",
      }));
    } else {
      // Track feature usage for clicking Next after file upload
      trackFeatureUsage("Quick Match JD - Next", {
        file_count: files.length,
        file_types: files.map((f) => f.type),
        timestamp: new Date().toISOString(),
      });
      uploadFile("NextUpload", setFiles);
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleJobTitle = (e) => {
    setJobTitle(e.target.value);
  };

  const handleGenerateUploadClick = async () => {
    if (candidateFiles.length == 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      // Track feature usage for clicking Generate Report after candidate upload
      trackFeatureUsage("Quick Match: Generate Report", {
        file_count: candidateFiles.length,
        file_types: candidateFiles.map((f) => f.type),
        timestamp: new Date().toISOString(),
      });

      setUploadJobDataList([]);
      uploadFile("Upload-Candidate", setCandidateFiles);
    }
  };

  const headerData = ["Candidate", "Score", ""];
  const handleAddMoreCandidateClick = () => {
    if (addMoreCandidateFiles.length == 0) {
      setSnackbarState({
        open: true,
        message: "Upload the Files",
        severity: "error",
      });
    } else {
      setUploadJobDataList([]);
      uploadFile(
        "Upload-Candidate",
        setAddMoreCandidateFiles,
        "Add-more-Candidate"
      );
    }
  };

  const handleAddMoreCandidate = () => {
    setAddMoreCandidateDialogOpen(true);
    setAddMoreCandidateFiles([]);
  };
  const handleMenuItem = (value, name) => {
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddMoreCandidateDialogClose = () => {
    setAddMoreCandidateDialogOpen(false);
    setAddMoreCandidateFiles([]);
  };

  const handleWrongClose = () => {
    setWrongClose(false);
    if (
      value === 1 &&
      Array.isArray(uploadJobDataList) &&
      uploadJobDataList.length !== 0
    ) {
      setValue(2);
    }
  };

  const handleViewJob = () => {
    navigate("/jobs");
  };

  const handleResumeDelete = (row) => {
    setDeleteResume(true);
    setResumeRow(row);
  };

  const handleDeleteDialogClose = () => {
    setDeleteResume(false);
  };

  const handleDelete = async () => {
    setDeleteButtonLoading(true);

    try {
      if (
        localStorageData?.organization === "Demo" &&
        localStorageData?.role === "Demo"
      ) {
        const data = reviewMatchData.filter((i) => i.id !== resumeRow.id);
        console.log(
          resumeRow,
          "resumeRowresumeRow",
          reviewMatchData.filter((i) => i.id !== resumeRow.id),
          data
        );
        dispatch({
          type: QUICKMATCH.reviewMatch,
          data: data,
        });
        setDeleteButtonLoading(false);
        handleDeleteDialogClose();
        handleReviewMatchInformation();
        setSnackbarState({
          open: true,
          message: "Delete Sucessfully",
          severity: "success",
        });
      } else {
        const data = await JobJobDelete(resumeRow.id);
        setDeleteButtonLoading(false);
        handleDeleteDialogClose();
        handleReviewMatchInformation();
        setSnackbarState({
          open: true,
          message: data?.message,
          severity: "success",
        });
      }
    } catch (error) {
      setDeleteButtonLoading(false);
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const QontoStepIcon = (props) => {
    const { active, completed } = props;
    const index = props.icon - 1;

    if (completed || (index === 2 && active)) {
      return <StepperActiveIco size={"28"} />;
    }
    if (active) {
      return <StepperInprogressIco size={"28"} />;
    } else return <PageStepperDefaultIco size={"28"} />;
  };

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Typography sx={{ fontSize: "24px", fontWeight: 600 }}>
            {"Quick Match"}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Box width="100%">
            <StepperStyle activeStep={value}>
              {tabData.map((step, index) => (
                <Step
                  key={step.label}
                  style={{
                    padding:
                      index === 2
                        ? "0px 0px 0px 1.2rem"
                        : index === 0
                        ? "0px 1.2rem 0px 0px"
                        : "0px 1.2rem",
                  }}
                >
                  <StepLabel StepIconComponent={QontoStepIcon}>
                    <CommonGrid2
                      display="flex"
                      flexDirection="column"
                      gap="5px"
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Typography
                        variant="span"
                        color="#344054"
                        fontWeight={600}
                      >
                        {step.label}
                      </Typography>

                      <Typography
                        variant="span"
                        color={
                          step.status === "Completed"
                            ? "#17B26A"
                            : step.status === "In Progress"
                            ? "#7F56D9"
                            : "#5B738B"
                        }
                      >
                        {step.status}
                      </Typography>
                    </CommonGrid2>
                  </StepLabel>
                </Step>
              ))}
            </StepperStyle>

            {value === 0 && (
              <UploadJobInformation
                handleDragOver={handleDragOver}
                handleDragLeave={handleDragLeave}
                handleDrop={handleDrop}
                handleFileUpload={handleFileUpload}
                isDragging={isDragging}
                files={files}
                handleDeleteFile={handleDeleteFile}
                handleNextUploadClick={handleNextUploadClick}
                handleJobTitle={handleJobTitle}
                jobTitle={jobTitle}
                isLoading={isLoading}
                buttonDisabled={buttonDisabled || files.length === 0}
                tabData={tabData}
                userData={userData}
                handleMenuItem={handleMenuItem}
                handleDataTime={(newValue) =>
                  handleDataTime(newValue, setUserData)
                }
              />
            )}

            {value === 1 && (
              <UploadCandidate
                handleCandidateDragOver={handleCandidateDragOver}
                handleCandidateDragLeave={handleCandidateDragLeave}
                handleCandidateDrop={handleCandidateDrop}
                handleCandidateFileUpload={handleCandidateFileUpload}
                candidateFiles={candidateFiles}
                isCandidateDragging={isCandidateDragging}
                handleCandidateDeleteFile={handleCandidateDeleteFile}
                isLoading={isLoading}
                buttonDisabled={buttonDisabled || candidateFiles.length === 0}
                handleGenerateUploadClick={handleGenerateUploadClick}
                uploadJobData={uploadJobData}
                tabData={tabData}
              />
            )}

            {value === 2 && (
              <ReviewMatch
                handleAddMoreCandidateDragOver={handleAddMoreCandidateDragOver}
                handleAddMoreCandidateDragLeave={
                  handleAddMoreCandidateDragLeave
                }
                handleAddMoreCandidateDrop={handleAddMoreCandidateDrop}
                handleAddMoreCandidateFileUpload={
                  handleAddMoreCandidateFileUpload
                }
                addMoreCandidateFiles={addMoreCandidateFiles}
                isAddMoreCandidateDragging={isAddMoreCandidateDragging}
                handleAddMoreCandidateDeleteFile={
                  handleAddMoreCandidateDeleteFile
                }
                handleQmShare={handleQmShare}
                shareDialogOpen={shareDialogOpen}
                handleShareDialogClose={handleShareDialogClose}
                tableLoader={tableLoader}
                reviewMatchData={reviewMatchData}
                handleAddMoreCandidateClick={handleAddMoreCandidateClick}
                headerData={headerData}
                addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
                handleAddMoreCandidate={handleAddMoreCandidate}
                handleAddMoreCandidateDialogClose={
                  handleAddMoreCandidateDialogClose
                }
                isLoading={isLoading}
                buttonDisabled={buttonDisabled}
                handleViewJob={handleViewJob}
                handleResumeDelete={handleResumeDelete}
              />
            )}
          </Box>
        </Grid2>

        <SnackBar
          snackbarState={snackbarState}
          handleCloseValidation={handleCloseValidation}
        />
        <SkillDeleteDialog
          deleteDialog={deleteResume}
          handleDeleteDialogClose={handleDeleteDialogClose}
          handleDeleteSkill={handleDelete}
          buttonLoading={deleteButtonLoading}
          title="Delete Candidate"
          content={resumeRow.candidate_name}
        />
        <ErrorDialog
          wrongClose={wrongClose}
          uploadJobDataList={uploadJobDataList}
          handleWrongClose={handleWrongClose}
        />
      </Grid2>
    </CustomDiv>
  );
}

export default QuickMatch;
